import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useDocumentTitle = () => {
    const [platformName, setPlatformName] = useState('');

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/configuracion/public`);
                const name = response.data?.nombre_plataforma || 'PaySync';
                setPlatformName(name);
                document.title = name;
            } catch (error) {
                console.error('Error fetching platform config:', error);
                document.title = 'PaySync';
            }
        };

        fetchConfig();
    }, []);

    return platformName;
};

export default useDocumentTitle;
